import styled, { css } from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { Button } from '../../styles/customComponents';

export const Content = styled.div`
  align-self: center;
  position: relative;

  form {
    display: flex;

    div:first-child {
      transition: transform 0.3s ease;
      z-index: 2;
      ${({ open }) =>
        open &&
        css`
          outline: none;
          transform: translateX(-67px);
        `}
    }
  }
  
  input {
    background-clip: padding-box;
    border: 1px solid ${styles.colors.GRAY_LIGHT_2};
    border-image: initial;
    border-radius: 3px;
    height: 45px;
    ${mixins.fontStyle(
      styles.colors.GRAY_DARKER,
      styles.fontSizes.SIZE_7,
      styles.fontWeights.SEMIBOLD
    )};
    letter-spacing: -0.1px;
    margin-top: 0;
    padding: 5px 10px;
    position: relative;
    text-align: left;
    width: 80px;
  }
  button {
    ${({ open }) =>
      !open &&
      css`
        outline: none;
      `}
  }
`;

export const ButtonSave = styled(Button)`
  height: 45px;
  position: absolute;
  right: 0;
  width: 62px;
  padding: 0;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/InputSave/style.js